import { render, staticRenderFns } from "./TextFieldTegaki.vue?vue&type=template&id=79a7129b&scoped=true&lang=pug"
import script from "./TextFieldTegaki.vue?vue&type=script&lang=ts"
export * from "./TextFieldTegaki.vue?vue&type=script&lang=ts"
import style0 from "./TextFieldTegaki.vue?vue&type=style&index=0&id=79a7129b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a7129b",
  null
  
)

export default component.exports